import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ParTypePriseEnCharge from './par-type-prise-en-charge';
import ParTypePriseEnChargeDetail from './par-type-prise-en-charge-detail';
import ParTypePriseEnChargeUpdate from './par-type-prise-en-charge-update';
import ParTypePriseEnChargeDeleteDialog from './par-type-prise-en-charge-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ParTypePriseEnChargeUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ParTypePriseEnChargeUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ParTypePriseEnChargeDetail} />
      <ErrorBoundaryRoute path={match.url} component={ParTypePriseEnCharge} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ParTypePriseEnChargeDeleteDialog} />
  </>
);

export default Routes;
